<template>

  <ion-page id="whatsnew-page">
     <ion-content >
       <div :class="{ 'text-dark' : isDark,'text-light' : !isDark }" 
             :style="styleOneFrame" :key="menuTrigger">
    
        <ion-item>
          <ion-label color="secondary">
            <h1>{{ t("Welcome to Chessvis Version") }} {{ versionMajor }}!</h1>
          </ion-label>
        </ion-item>
        <ion-item>
          V11.0 - {{ t("AI comes the the Opening Explorer. GenAI gives insight into which moves are better based on how you'll enter in the middle game.") }}
        </ion-item>
        <ion-item>
          V11.0 - {{ t("All Puzzles are Free! Total redo of the 'landing page'. And finally, a menu system that shows off what Chessvis has. AND for subscribers, the Maia chess engine is available!") }}
        </ion-item>
        <ion-item>
          V10.1 - {{ t("Run 'Verbal Chess' right inside 'Chessvis'! Access the new Cloud AI Voices and multiple languages. (It's on the left-hand menu.)") }}
        </ion-item>
        <ion-item>
          V10.0 - {{ t("Chessvis speaks your language! Starting with: Spanish, French, Italian, German and Portuguese. Suggest others? Subscribers can pick their favorite puzzle categories! And 'Eye Gaze' gets reworked and embedded in Chessvis. With it, you can use an 'eye tracker' to play. And since it now works on phones, users who don't need an eye tracker might find the move selection easy using just 'two thumbs'. Find the toolbar buttons too small on your screen? Now you can enlarge them.") }}
        </ion-item>
        <ion-item>
          V9.14 - {{ t("'Puzzle Rating' selection is improved. Now you can specify a range of any size. Plus the screen got a 'facelift' with the long list of checkboxes replaced by sliders. Also, on 'Puzzle Visualization' if you click on the wrong 'from' square, clicking on that same square again will just clear the 'from' selection.") }}
        </ion-item>
          <ion-item>
          V9.13 - {{ t("'Repertoire Import' under 'Legacy Repertoires' is working. (Since it is drag&drop, this will only be available on the Web version but once a repertoire is imported, it can be used anywhere.)") }}
        </ion-item>
        <ion-item>
          V9.12 - {{ t("Information on how to 'Cancel Subscription' under 'Account' menu.") }}
        </ion-item>
        <ion-item>
          V9.11 - Android system required updates to SDK 35 and BillingClient V8. (I'm always fearful of having to upgrade components because of possible breakage. Please report any problems you find.)
        </ion-item>
        <ion-item>
          V9.10 - Repertoire Drill doesn't flag as errors moving the right piece to an invalid square. Chessboard colors set with 'Preferences' are used for both light &amp; dark screens.
        </ion-item>
        <ion-item>
          V9.9 - Puzzle Categories now include opening themes AND display categories in groups for easy navigation.
        </ion-item>
        <ion-item>
          V9.8 - 'Learn With Coach' gets voice chat! If you are a coach, please contact me. If you're a student, please tell your coach! PLUS, if you find the 'Hint' button too much of a temptation on puzzles, there's a 'Preferences' option to disable it.
        </ion-item>
        <ion-item>
          V9.7 - 'Learn With Coach' gets a major enhancement with game review, annotate board with highlighted squares and arrows, clipboard copy/paste of both board positions and entire games and promotion to any piece. If you are a coach, please contact me. If you're a student, please tell your coach!
        </ion-item>
        <ion-item>
          V9.6 - The beginning of an entirely new section within Chessvis. The 'Learn' section. The first entry there is a routine that enables coaches and students to work together on the same board with integrated chat. The best part is that it works the same on the web, Android and IOS devices. Desktop, phones and tablets. If you are a coach, please contact me. If you're a student, please tell your coach!
        </ion-item>
        <ion-item>
          V9.5 - Added Puzzle History and Download. Added Master Game Download. Both of those were in previous versions of Chessvis but were missed when building version 9.
        </ion-item>
        <ion-item>
          V9.4 - Opening Explorer and Repertoire routines can make moves that are outside the rating filter. Moves that weren't played in games within the rating filter will be shown after the 'within rating range' moves and will show the word 'all' in the percentage space. Also, enhanced the color on the repertoire tree branch indicators.
        </ion-item>
        <ion-item>
          V9.3 - Opening Explorer can copy the FEN of the current board OR a PGN of the entire move sequence to the clipboard.
        </ion-item>
        <ion-item>
          V9.2 - New Puzzle features! For timed puzzles, you'll find a new option to set when the timer will start. Setting the timer to start when you make the first move lets you focus on the entire puzzle's solution instead of just the first move. Separately, you can set the number of visualized moves to zero enabling you to work on regular puzzles while having to keep the move changes in your mind.
        </ion-item>
        <ion-item>
          V9.1.10 - Play Computer and Blindfold can now 'Replay' the last 5 moves. This is useful especially when you step away from a game and need to refresh your thoughts. Also, for IOS and Android, subscription prices are shown with the local currency symbol.
        </ion-item>
        <ion-item>
          V9.1.9 - Repertoire 'Drill' works properly when lines end with opponent's move
        </ion-item>
        <ion-item>
          V9.1.8 - Fixed problem on IOS devices when in 'zoom' text mode
        </ion-item>
        <ion-item>
          V9.1.7 - Fix problem with Blindfold play not revealing every specified number of moves. Also, 'continue game' tracks if it is a regular computer game or blindfold
        </ion-item>
        <ion-item>
          V9.1.5 - the "Move Following" exercises now show the moves for you to 'review' if you have replication errors. <i>And the 'email verification' screen error has been fixed.</i>
        </ion-item>
        <ion-item>
          The 'App Landing Page' is now integrated into the web program itself. This will eliminate the need for a 'go to web' button. Instead, you'll be right there in the program. Even better, the new version keeps track of the last routine you used so when you run Chessvis another day, you start where you left of and don't have to see the 'Welcome' page each time. (All comments on it are welcome, you can find it under the 'Support' menu.)
        </ion-item>
        <ion-item>
          <ion-label color="secondary">
          Web, Android and Iphone consistency
          </ion-label>
        </ion-item>
        <ion-item>
          I'm very excited about this version because it uses some extra libraries that enable me to use the same code for the web, Iphone and Android versions.
        </ion-item>
        <ion-item>
          You'll notice a completely different menu look. No more having to go back up multiple levels to switch to other program areas. (You can see how this will work better on mobile devices.)
        </ion-item>
        <ion-item>
          <ion-label color="secondary">
          Filling-in some missing pieces
          </ion-label>
        </ion-item>
        <ion-item>
          Offline Puzzles! A subscriber favorite that has been in the two native versions but not on the web is there. PLUS, offline puzzles now extend to visualization, timed and blindfold.
        </ion-item>
        <ion-item>
          Continue Blindfold and Computer games! This also has been in the two native versions and is here now.
        </ion-item>
        <ion-item>
          <ion-label color="secondary">
          Opening Mastery has been folded into Chessvis.
          </ion-label>
        </ion-item>
        <ion-item>
        Yes, I know only a month ago I said I was going to separate it out but converting the code to this new version that supports all 3 platforms went so fast I decided to go back to the original concept.
        </ion-item>
        <ion-item>
          The opening/repertoires from the current Chessvis web is included under the "Legacy" headings. I felt it was important to add those because its approach is different than "Opening Mastery" and there really isn't an upgrade path. (Only missing piece is 'repertoire import'.)
        </ion-item>
        <ion-item>
          <ion-label color="secondary">
          Look and Feel Improvements
          </ion-label>
        </ion-item>
        <ion-item>
          I have spent sometime on the look and feel. For example, no program has more than 5 toolbar buttons. The Help/Tour button is now an "information" icon on the menus. I'm most pleased with getting the puzzle program from 8(!) to 5 buttons.
        </ion-item>
        <ion-item>
          I have yet to think about the Opening Explorer experience on small devices. I definitely will. I had always thought about them as bigger screen tools but will make them usable on the small screens.
        </ion-item>
        <ion-item>
          <ion-label color="secondary">
            <h1>I need your input so I don't miss anything.</h1>
            <p>What else is neede????</p>
            <p>Henry    ***   henry@chessvis.com</p>
          </ion-label>
        </ion-item>
      </div>
    </ion-content>
   </ion-page>
  </template>
  
  <script setup>
  
  import { IonLabel,IonItem,IonInput,IonPage, IonContent } from '@ionic/vue';
  
  import { ref, watch } from 'vue'
  import { doStartupCheck } from '@/composables/startupCheck.js'
  import { useConnectionStore } from '@/stores/connectionStore';
  import { useWindowSizeStore } from '@/stores/windowSizeStore';
  import { t } from '@/composables/translateText.js'

  import { availableWidthHeight } from '@/composables/screenSize'
  const connectionStore = useConnectionStore()
    
  const versionMajor = ref(connectionStore.versionMajor)
  const isDark = ref(connectionStore.getDarkmode != "" && connectionStore.getDarkmode != "light")
  const menuTrigger = ref(0)
  
  const styleOneFrame = ref({
     position : "absolute",
     "overflow-y" : "scroll",
     top : "0px",
     left : "100px",
     width: "100px",
     height : "100px"
   })
  
   const source = ref("https://www.chessvis.com/")
  
  const windowSizeStore = useWindowSizeStore()
  const windowSizeRef = ref({ width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] })
  updateWidthHeights()
  
  doStartupCheck(false)
  
  watch(() => windowSizeStore.getWindowSize, () => {
      //console.log('*********** window size changes detected')
      windowSizeRef.value = { width : windowSizeStore.getWindowSize['width'],
                        height : windowSizeStore.getWindowSize['height'] }
      //console.log("*** logoff new window size",windowSizeRef.value)
      menuTrigger.value++
      updateWidthHeights()
    })
    
  
  function updateWidthHeights() {
  
const availableSpace = availableWidthHeight()

    // don't need room for the toolbar
    const whichMenu = localStorage.getItem("whichMenu")
    const showBigButtons = whichMenu == "buttons" || connectionStore.getShowBigButtons
    var footerHeight = connectionStore.getToolbarHeight
    if (showBigButtons)
      footerHeight = Math.floor(footerHeight * connectionStore.getToolbarScalePercentage / 100.0)

    const oneframePositionTop = availableSpace.topIndent
    const oneframePositionLeft = availableSpace.leftRightIndent + availableSpace.leftIndent
    const oneframeHeight = availableSpace.height - oneframePositionTop + availableSpace.topIndent + footerHeight
    const oneframeWidth = availableSpace.width - availableSpace.leftRightIndent * 2

    styleOneFrame.value.height = oneframeHeight + "px"
    styleOneFrame.value.width = oneframeWidth + "px"
    styleOneFrame.value.top = oneframePositionTop + "px"
    styleOneFrame.value.left = oneframePositionLeft + "px"
  }
  
  </script>
  
  <style scoped>
  
  .item{
    margin:10px auto;
  }
  
  </style>